import { saveEntities } from '../factories'
import { showFeedback } from '../feedback/factories'
import { sequences as route } from '../route'
import * as actions from './actions'

const setGroupParam = ({ props: { entities: { resourceGroups = [] } = {} } }) => {
  return { params: { resourceGroup: resourceGroups[0]?._id } }
}

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  saveEntities(),
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Group deleted', type: 'success' }),
  findForList,
  setGroupParam,
  route.toResources,
]

export const updateOrder = [
  //
  actions.updateOrder,
  findForList,
]
